
import { activeSync } from '../api'
import notifications from '../notifications'

var _currentData = undefined

function _remapData(originalData) {
  return {
    id: originalData.id,
    transferDate: originalData.date,
    createdAt: originalData.created_at,
    internalId: originalData.student.internal_id,
    firstName: originalData.student.first_name,
    lastName: originalData.student.last_name,
  }
}

async function _getData(params) {
  try {
    let response = await activeSync.getTransferDate(params)
    _currentData = response.data
    return _currentData
  }
  catch (error) {
    notifications.pushError(`Unable to load Transfer Student Dates! ${error.response.data.error}`, error)
  }
}

async function _deleteByIds(ids) {
  try {
    let response = await activeSync.postTransferDateDelete({ ids: ids })
    return response.data
  }
  catch (error) {
    notifications.pushError(`Unable to delete selected Transfer Student Dates! ${error.response.data.error}`, error)
    throw ids
  }
}

export default {
  remapData: _remapData,
  getData: _getData,
  deleteByIds: _deleteByIds,
}
